function toK(value: number, u: string): number {
  switch (u) {
    case 'c': case 'delta_c': return value + 273.15;
    case 'f': case 'delta_f': return (value - 32) * 5/9 + 273.15;
    case 'k': return value;
    case 'r': return value * 5/9;
    default: throw new Error(`Unknown temp unit: ${u}`);
  }
}

function fromK(k: number, u: string): number {
  switch (u) {
    case 'c': case 'delta_c': return k - 273.15;
    case 'f': case 'delta_f': return (k - 273.15) * 9/5 + 32;
    case 'k': return k;
    case 'r': return k * 9/5;
    default: throw new Error(`Unknown temp unit: ${u}`);
  }
}

export function tempConvert(value: number, fromU: string, toU: string): number {
  const isDelta = fromU.startsWith('delta_') || toU.startsWith('delta_');
  if (isDelta) {
    const toCelsius = fromU === 'delta_f' || fromU === 'f' ? value * 5/9 : value;
    return toU === 'delta_f' || toU === 'f' ? toCelsius * 9/5 : toCelsius;
  }
  return fromK(toK(value, fromU), toU);
}
